var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8EngineCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "15. Engine Check"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 55,
    r: 50,
    fill: "#e7efff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4,
    r: 3,
    fill: "#ff4d69"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 10,
    r: 3,
    fill: "#00c99f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 97,
    r: 3,
    fill: "#ffa100"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 106,
    r: 3,
    fill: "#00c99f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4e6aff",
    d: "M87,45V76.34a4,4,0,0,1-1.17,2.83l-4.66,4.66A4,4,0,0,1,78.34,85H34.2a4,4,0,0,1-3.38-1.85L25,74H19a4,4,0,0,1-4-4V44a4,4,0,0,1,4-4h5.23l5.6-9.1A4,4,0,0,1,33.24,29H70.7a4,4,0,0,1,3.46,2L80,41h3A4,4,0,0,1,87,45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 14,
    x: 9,
    y: 50,
    fill: "#323fd4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 14,
    x: 86.98,
    y: 50,
    fill: "#323fd4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4e6aff",
    d: "M9,42V72a2,2,0,0,1-2,2H4.74A50.12,50.12,0,0,1,3.3,40H7A2,2,0,0,1,9,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4e6aff",
    d: "M105,44.83V69.17a2,2,0,0,1-.59,1.42l-2.82,2.82a2,2,0,0,1-1.42.59H95a2,2,0,0,1-2-2V42a2,2,0,0,1,2-2h5.17a2,2,0,0,1,1.42.59l2.82,2.82A2,2,0,0,1,105,44.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 14,
    x: 47.99,
    y: 19.01,
    fill: "#323fd4",
    transform: "rotate(-90 50.99 26.01)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4e6aff",
    d: "M38.82,11H63.16a2,2,0,0,1,1.41.58L67.4,14.4A2,2,0,0,1,68,15.82V21a2,2,0,0,1-2,2H36a2,2,0,0,1-2-2V15.82a2,2,0,0,1,.58-1.42l2.83-2.83A2,2,0,0,1,38.82,11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.07,
    height: 5.66,
    x: 31.96,
    y: 81.67,
    fill: "#7f96d1",
    transform: "rotate(-45 35.5 84.496)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 69,
    r: 21,
    fill: "#a5bced"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 69,
    r: 15,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.66,
    height: 14.14,
    x: 28.17,
    y: 81.93,
    fill: "#a5bced",
    rx: 2,
    transform: "rotate(-45 31.004 88.998)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f96d1",
    d: "M32,94l-4.91,4.91a48.51,48.51,0,0,1-7.21-4.79L26,88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 36,
    r: 3,
    fill: "#8fa2ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 36,
    r: 3,
    fill: "#8fa2ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 36,
    r: 3,
    fill: "#8fa2ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c99f",
    d: "M48.59,74.41l-5-5a2,2,0,0,1,2.82-2.82L50,70.17l6.59-6.58a2,2,0,0,1,2.82,2.82l-8,8A2,2,0,0,1,48.59,74.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323fd4",
    d: "M80,41H69a1,1,0,0,1,0-2h9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,70H20a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82,47H78a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8EngineCheck);
export default __webpack_public_path__ + "static/media/icons8-engine-check.511f735adb9aa68d80aec517c00689fb.svg";
export { ForwardRef as ReactComponent };